export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", imageSeq: "cat-shoes-01", desc: "Curated sneaker finds — Nike, Adidas, Yeezy, and trending footwear from verified spreadsheet links." },
  { name: "Hoodies & Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html", imageSeq: "cat-hoodies-01", desc: "Premium hoodies and crewnecks — streetwear staples, oversized fits, and seasonal layers." },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html", imageSeq: "cat-tshirts-01", desc: "Essential tees from classic logos to minimalist designs — updated weekly with fresh spreadsheet links." },
  { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html", imageSeq: "cat-jackets-01", desc: "Bombers, denim jackets, puffers, and varsity styles — top-rated outerwear from trusted sellers." },
  { name: "Pants & Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html", imageSeq: "cat-pants-01", desc: "Cargo pants, denim, tech fleece bottoms, and summer shorts for every fit preference." },
  { name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html", imageSeq: "cat-headwear-01", desc: "Caps, beanies, and bucket hats — complete your outfit with spreadsheet-approved headwear." },
  { name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html", imageSeq: "cat-sets-01", desc: "Matching tracksuits, co-ord sets, and full outfits curated from the best spreadsheet collections." },
  { name: "Underwear", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html", imageSeq: "cat-underwear-01", desc: "Quality underwear and undergarments — comfortable basics sourced through verified agents." },
  { name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html", imageSeq: "cat-jersey-01", desc: "Football, basketball, and soccer jerseys — replica sports kits with high accuracy ratings." },
  { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html", imageSeq: "cat-accessories-01", desc: "Wallets, sunglasses, scarves, and jewelry — finishing touches from curated spreadsheet finds." },
  { name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html", imageSeq: "cat-bags-01", desc: "Luxury handbags, backpacks, and crossbody bags — designer-inspired pieces with detailed reviews." },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html", imageSeq: "cat-belts-01", desc: "Leather belts and statement buckles — affordable accessories for any wardrobe." },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html", imageSeq: "cat-perfumes-01", desc: "Designer-inspired fragrances — long-lasting scents at a fraction of retail prices." },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html", imageSeq: "cat-other-01", desc: "Home goods, tech accessories, and surprise gems — unique spreadsheet discoveries." },
];

export const articleCards = [
  {
    title: "What Is Sugargoo Spreadsheet? Complete Beginner Guide",
    slug: "what-is-sugargoo-spreadsheet",
    excerpt: "Learn everything about Sugargoo spreadsheets — how they work, why shoppers use them, and how to find the best replica finds in 2026.",
    imageSeq: "article-what-is-01",
    readTime: "8 min read",
  },
  {
    title: "How to Use Sugargoo Spreadsheet Step by Step",
    slug: "how-to-use-sugargoo-spreadsheet",
    excerpt: "A practical walkthrough on navigating Sugargoo spreadsheets, placing orders, and avoiding common beginner mistakes.",
    imageSeq: "article-how-to-01",
    readTime: "6 min read",
  },
  {
    title: "Sugargoo vs Pandabuy Spreadsheet Comparison",
    slug: "sugargoo-vs-pandabuy-spreadsheet",
    excerpt: "An honest side-by-side comparison of Sugargoo and Pandabuy spreadsheets — pricing, selection, shipping, and user experience.",
    imageSeq: "article-compare-01",
    readTime: "7 min read",
  },
  {
    title: "Is Sugargoo Safe? Full Risk Analysis & Tips",
    slug: "is-sugargoo-safe",
    excerpt: "Unbiased safety review covering customs risks, shipping reliability, and practical tips to protect your orders.",
    imageSeq: "article-safety-01",
    readTime: "5 min read",
  },
  {
    title: "Beginner Mistakes When Using Sugargoo Spreadsheet",
    slug: "beginner-mistakes-sugargoo-spreadsheet",
    excerpt: "Avoid the 10 most common pitfalls new spreadsheet shoppers make — save money and frustration with these essential tips.",
    imageSeq: "article-mistakes-01",
    readTime: "5 min read",
  },
  {
    title: "Why People Use Spreadsheets Instead of Websites",
    slug: "why-people-use-spreadsheets",
    excerpt: "Discover why the Sugargoo spreadsheet shopping method has become the go-to for savvy international buyers worldwide.",
    imageSeq: "article-why-01",
    readTime: "4 min read",
  },
  {
    title: "Best Sugargoo Spreadsheet Finds 2026 (Updated)",
    slug: "best-sugargoo-spreadsheet-finds-2026",
    excerpt: "The most comprehensive roundup of top-rated Sugargoo spreadsheet discoveries across all major categories this year.",
    imageSeq: "article-finds-01",
    readTime: "9 min read",
  },
  {
    title: "Top 20 Sneakers on Sugargoo Spreadsheet",
    slug: "top-sneakers-sugargoo-spreadsheet",
    excerpt: "From Jordan retros to Nike Dunks — the 20 highest-rated sneaker listings on Sugargoo spreadsheets right now.",
    imageSeq: "article-sneakers-01",
    readTime: "7 min read",
  },
  {
    title: "Best Clothing Items Spreadsheet List 2026",
    slug: "best-clothing-sugargoo-spreadsheet",
    excerpt: "Hoodies, tees, jackets, and pants — the essential clothing spreadsheet that serious fashion shoppers bookmark.",
    imageSeq: "article-clothing-01",
    readTime: "6 min read",
  },
  {
    title: "Luxury Replica Bags Spreadsheet Guide",
    slug: "luxury-bags-spreadsheet-guide",
    excerpt: "Navigate the world of designer-inspired bags with our curated spreadsheet directory and quality assessment tips.",
    imageSeq: "article-bags-01",
    readTime: "6 min read",
  },
  {
    title: "Cheapest Items on Sugargoo Spreadsheet",
    slug: "cheapest-items-sugargoo-spreadsheet",
    excerpt: "Budget-friendly spreadsheet gems under $30 — proof that you do not need to spend big to shop smart.",
    imageSeq: "article-cheap-01",
    readTime: "5 min read",
  },
  {
    title: "Sugargoo vs CSSBuy Full Breakdown 2026",
    slug: "sugargoo-vs-cssbuy-spreadsheet",
    excerpt: "Detailed agent comparison covering fees, shipping speed, spreadsheet quality, and overall buyer experience.",
    imageSeq: "article-vscss-01",
    readTime: "7 min read",
  },
  {
    title: "How to Avoid Customs Seizure When Using Spreadsheet",
    slug: "customs-seizure-avoidance-guide",
    excerpt: "Practical strategies to minimize customs risk when ordering through Sugargoo spreadsheets — stay safe and informed.",
    imageSeq: "article-customs-01",
    readTime: "6 min read",
  },
];